import axiosInstance from "../../../helpers/api";

export const getAdminNotifications = () => {
  return axiosInstance.get(`/admin/Reports/admin_notifications`);
};

